import React from "react";
import { ShieldCheck } from "lucide-react";

const SECTIONS = [
  { h: "1. Information We Collect", list: [
    "Account Information: If you register an account, we may collect your email address and encrypted authentication credentials.",
    "Usage & Technical Data: Standard server log information, including IP address, browser type, operating system, and timestamp data, collected automatically for network security and site performance.",
    "User Submissions: The star ratings, selected tags, and written feedback text you choose to submit regarding supervisors or companies.",
  ] },
  { h: "2. Anonymity & Public Content", list: [
    "Public Visibility: Ratings, feedback text, and selected tags submitted on supervisor profiles are publicly visible.",
    "Identity Shielding: We do not display your name, user ID, or email address alongside your submitted reviews.",
    "Self-Identification Warning: Users are solely responsible for ensuring that their written text does not inadvertently contain unique scenarios, specific details, or phrasing that could reveal their identity to third parties.",
  ] },
  { h: "3. How We Use Your Information", intro: "We use collected data solely to:", list: [
    "Operate, maintain, and improve the My360Boss platform.",
    "Authenticate user access and prevent platform abuse, automated spam, or duplicate review manipulation.",
    "Respond to customer support or legal inquiries.",
  ] },
  { h: "4. Data Sharing & Disclosure", list: [
    "We do NOT sell, rent, or trade your personal data or user identity to employers, third-party advertisers, or data brokers.",
    "We will only disclose account details or technical logs if strictly required by a valid law enforcement subpoena, court order, or binding legal command.",
  ] },
  { h: "5. Data Security", p: "We implement industry-standard security measures (including SSL/TLS encryption and hashed credentials) to safeguard your data. However, no internet transmission or electronic storage method is 100% secure." },
  { h: "6. Contact Us", p: "For any privacy questions or requests regarding your data, please contact us at support@my360boss.com." },
];

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12">
      <p className="font-mono text-xs uppercase tracking-widest text-emerald-600 mb-2">Legal</p>
      <h1 className="font-display text-5xl text-slate-900 mb-3 flex items-center gap-3" style={{ fontWeight: 900 }}>
        <ShieldCheck className="text-emerald-600" size={38} /> Privacy Policy
      </h1>
      <p className="text-xs text-slate-400 font-mono mb-6">Last Updated: August 24, 2026</p>

      <p className="text-slate-600 leading-relaxed mb-8">
        My360Boss ("we," "our," or "us") is committed to protecting user privacy while facilitating open
        workplace transparency. This Privacy Policy explains how we collect, use, and protect your
        information when you visit my360boss.com.
      </p>

      <div className="space-y-6" data-testid="privacy-sections">
        {SECTIONS.map((s, i) => (
          <div key={i}>
            <h2 className="font-display text-xl text-slate-900 mb-1" style={{ fontWeight: 700 }}>{s.h}</h2>
            {s.p && <p className="text-slate-600 leading-relaxed text-sm">{s.p}</p>}
            {s.intro && <p className="text-slate-600 leading-relaxed text-sm mb-2">{s.intro}</p>}
            {s.list && (
              <ul className="list-disc pl-5 space-y-1.5 text-sm text-slate-600">
                {s.list.map((li, j) => <li key={j} className="leading-relaxed">{li}</li>)}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
